import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Container,
    Typography,
  } from "@mui/material";

  import { Link, useNavigate } from "react-router-dom";
  import { useSelector } from "../store";

  import React, { useEffect } from "react";
  import plus from "../assets/images/website/plus.png";
  
  function WhyPovego() {
    const [expanded, setExpanded] = React.useState(false);
    const navigate = useNavigate()
    const { username } = useSelector((state) => state.auth);

    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };
    return (
      <React.Fragment>
        <Container maxWidth="xl">
            <Box
              sx={{
                maxWidth: "1400px",
                padding: {xs: '65px 0px 107px' , lg: "140px 0px"},
                margin: "auto",
                textAlign: "center",
              }}
            >
            
              

              <Typography
                sx={{
                  color: "#000",
                  fontWeight: 700,
                  fontFamily: '"Inter", sans-serif',
                  fontSize: { xs: 36, lg: 54 },
                  lineHeight: { xs: '44px', lg: "65px" },
                  maxWidth: '500px',
                  margin: { xs: 'auto', lg: 0 },
                  textAlign: { xs: 'center', lg: 'start' }
                }}
              >
               Why Povego?
              </Typography>
              <Typography
                sx={{
                  color: "#000",
                  fontWeight: 400,
                  fontFamily: '"Inter", sans-serif',
                  fontSize: { xs: 18, lg: 22 },
                  padding: "24px 0px 60px",
                  textAlign: { xs: 'center', lg: 'start' }
                }}
              >
                Our Advantages and Differences from Competitors<br/><br/>
                There are many reasons for you to choose Povego. First of all, our security priority, which stores your funds in cold wallets and protects them with multi-layer security measures, keeps your investments safe.<br/><br/>

                Thanks to our user-friendly interface that appeals to both beginners and professionals, you can trade quickly and easily. By offering a wide range of cryptocurrencies, we provide many investment opportunities from popular tokens to innovative projects. While offering the chance to obtain maximum earnings with our competitive commission rates and regular campaigns, we ensure you save time with our fast transaction and withdrawal processes. We are always by our users' side with Turkish 24/7 customer support and payment methods specific to Türkiye. You are at the right address for a reliable, fast, and user-oriented crypto investment experience.





              </Typography>
            </Box>
          </Container>
      </React.Fragment>
    );
  }
  
  export default WhyPovego;
  
